import { IconButton } from '../IconButton';
import { Typography } from '../Typography';

export interface BannerHeaderProps {
  text: string;
  showIcon?: boolean;
  onInfoPress?: () => void;
  infoAriaLabel?: string;
}

/**
 * Full-width banner with dark background and white text.
 * Used to display time-sensitive information (e.g. reservation countdown).
 * Mirrors the mobile BannerHeader primer component (state="timer").
 * @see src/primer/README.md
 */
export function BannerHeader({
  text,
  showIcon = true,
  onInfoPress,
  infoAriaLabel,
}: BannerHeaderProps) {
  return (
    <div className="w-full bg-media px-5 py-3 flex items-center gap-3">
      <div className="flex-1">
        <Typography variant="body" size="medium" color="white">
          {text}
        </Typography>
      </div>
      {showIcon && onInfoPress && (
        <div className="shrink-0">
          <IconButton
            icon="circle-info-filled"
            aria-label={infoAriaLabel ?? 'More information'}
            onClick={onInfoPress}
          />
        </div>
      )}
    </div>
  );
}
